import { useState } from "react";

export const useOpenSidebar = () => {
    const [isOpenSidebar, setIsOpenSidebar] = useState(false);

    const toggleSidebar = () => {
        setIsOpenSidebar((prevState) => !prevState);
    }

    return {
        isOpenSidebar,          // Retorna o estado atual do modal
        toggleSidebar // Função para alternar a visibilidade
    }
}